import React from "react";
import { useChair } from "../../../context/ChairContext";
import { useListChairVariants } from "../../../api/hooks/useChairs";
import { Step } from "./Step";
import { useStep } from "../../../context/stepContext";
import { Loader } from "../../Loader";
import { plausibleEvent } from "../../../utilities/helper";
import { ChairInfoButton } from "../ChairInfoButton";

type VariantOptionProps = {
    id: string;
    name: string;
    description: string;
    img: Array<{ url: string; title: string }>;
};

const VariantOption = (props: VariantOptionProps) => {
    const { chair, reset } = useChair();
    const handleClick = (event) => {
        event.stopPropagation();
        const url = new URL(window.location.href);
        url.searchParams.set("id", props.id);
        window.history.pushState({ id: props.id }, "", url);
        reset({
            id: props.id,
        });
        plausibleEvent("variant-selected", `${chair.modelName} ${props.name}`);
    };

    return (
        <li className={"variant-option"} onClick={handleClick}>
            {props.img.length > 0 ? (
                <img
                    className={"variant-preview"}
                    src={props.img[0].url}
                    width={50}
                    height={50}
                    alt={props.img[0].title}
                />
            ) : null}
            <div className={"variant-info"}>
                <div className={"variant-name"}>{props.name}</div>
                <div className={"variant-description"}>{props.description}</div>
            </div>
            <input type={"radio"} checked={chair.id === props.id} onChange={handleClick} />
        </li>
    );
};

export const VariantStep = () => {
    const { chair } = useChair();
    const { setStep } = useStep();
    const variantsQuery = useListChairVariants({ id: chair.modelId ?? "" });

    const variants = variantsQuery.isSuccess ? (variantsQuery.data.chairEntries[0].children ?? []) : [];

    return (
        <div className={"step variant-step"}>
            <button
                className={"button back-button icon-button"}
                onClick={() => {
                    setStep(Step.OVERVIEW);
                }}
            >
                Zurück
            </button>
            <h2 className={"heading"}>Wählen Sie Ihre {chair.modelName}-Variante</h2>
            <ChairInfoButton />
            {variantsQuery.isLoading ? (
                <Loader />
            ) : (
                <ul className={"variant-options"}>
                    {variants.map((variant) => {
                        return (
                            <VariantOption
                                key={variant.id}
                                id={variant.id}
                                name={variant.variantName}
                                description={variant.variantDescription}
                                img={variant.previewImage}
                            />
                        );
                    })}
                </ul>
            )}
        </div>
    );
};
